import { FC } from "react";
import { Grid } from "antd";
import useEmblaCarousel from "embla-carousel-react";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useDirection } from "src/i18n/direction";
import SectionWeb from "./layouts/Section.web";
import SectionMob from "./layouts/Section.mob";
import { SectionLayoutProps } from "./Section.types";

type Props = Omit<SectionLayoutProps, "emblaRef" | "emblaApi">;

const SectionComponent = withConditionalComponent<SectionLayoutProps, SectionLayoutProps>(SectionWeb, SectionMob);

const Section: FC<Props> = ({ title, items, index, subtitle }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const direction = useDirection();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    axis: "x",
    align: "start",
    dragThreshold: 10,
    inViewThreshold: 0.1,
    active: true,
    direction,
  });
  if (!items.length) return null;
  return <SectionComponent trigger={isLargeScreen} props={{ title, items, index, subtitle, emblaRef, emblaApi }} />;
};

export default Section;
